/**
 * ResumeProgressModal Component
 *
 * Shows when user has saved progress and asks if they want to continue or start fresh
 */

import Button from './Button'
import './ResumeProgressModal.css'

function ResumeProgressModal({ lastSaved, onResume, onStartFresh }) {
  const formatDate = (isoString) => {
    const date = new Date(isoString)
    const now = new Date()
    const diffMs = now - date
    const diffMins = Math.floor(diffMs / 60000)
    const diffHours = Math.floor(diffMs / 3600000)
    const diffDays = Math.floor(diffMs / 86400000)

    if (diffMins < 1) return 'just now'
    if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`
    return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content resume-modal">
        <div className="modal-icon">💾</div>
        <h2 className="modal-title">Continue where you left off?</h2>
        <p className="modal-message">
          You have saved progress from <strong>{formatDate(lastSaved)}</strong>.
          Would you like to continue or start fresh?
        </p>

        <div className="modal-actions">
          <Button variant="primary" size="lg" onClick={onResume}>
            ✓ Continue Progress
          </Button>
          <Button variant="secondary" size="md" onClick={onStartFresh}>
            Start Fresh
          </Button>
        </div>

        <p className="modal-hint">
          Your saved data is stored locally in your browser
        </p>
      </div>
    </div>
  )
}

export default ResumeProgressModal
